/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type SortingOption } from '@/types/legacy';

export const shelfPageType = {
  productShelf: 'ProductShelf',
  shopByMake: 'ShopByMake',
  shopByModel: 'ShopByModel',
};

export type DefaultSortingOptionsObject = { quickFilter: boolean; options: SortingOption[] };

const commonDefaultSortingOptions: SortingOption[] = [
  {
    tablet: true,
    desktop: true,
    '@type': 'ShelfPageBody_SortingOption',
    parameter: 'price-asc',
    name: 'Price (low to high)',
    mobile: true,
    enabled: true,
  },
  {
    tablet: true,
    desktop: true,
    '@type': 'ShelfPageBody_SortingOption',
    parameter: 'price-desc',
    name: 'Price (high to low)',
    mobile: true,
    enabled: true,
  },
];

const commonDefaultSortingOptionsForMX: SortingOption[] = [
  {
    tablet: true,
    desktop: true,
    '@type': 'ShelfPageBody_SortingOption',
    parameter: 'price-asc',
    name: 'Precio (de más bajo a más alto)',
    mobile: true,
    enabled: true,
  },
  {
    tablet: true,
    desktop: true,
    '@type': 'ShelfPageBody_SortingOption',
    parameter: 'price-desc',
    name: 'Precio (de más alto a más bajo)',
    mobile: true,
    enabled: true,
  },
];

export const defaultSortingOptions: DefaultSortingOptionsObject = {
  quickFilter: true,
  options: [
    ...commonDefaultSortingOptions,
    {
      tablet: true,
      desktop: true,
      '@type': 'ShelfPageBody_SortingOption',
      parameter: 'recently-added-desc',
      name: 'Recently Added',
      mobile: true,
      enabled: true,
    },
    {
      tablet: true,
      desktop: true,
      '@type': 'ShelfPageBody_SortingOption',
      parameter: 'customer-rating-desc',
      name: 'Customer Rating',
      mobile: true,
      enabled: true,
    },
    {
      tablet: true,
      desktop: true,
      '@type': 'ShelfPageBody_SortingOption',
      parameter: 'best-seller-desc',
      name: 'Best Sellers',
      mobile: true,
      enabled: true,
    },
  ],
};

export const defaultSortingOptionsForMX: DefaultSortingOptionsObject = {
  options: [
    ...commonDefaultSortingOptionsForMX,
    {
      tablet: true,
      desktop: true,
      '@type': 'ShelfPageBody_SortingOption',
      parameter: 'recently-added-desc',
      name: 'Añadido Recientemente',
      mobile: true,
      enabled: true,
    },
    {
      tablet: true,
      desktop: true,
      '@type': 'ShelfPageBody_SortingOption',
      parameter: 'best-seller-asc',
      name: 'Más Vendido',
      mobile: true,
      enabled: true,
    },
  ],
  quickFilter: true,
};

export const defaultSortingOptionsForBR: DefaultSortingOptionsObject = {
  options: [
    {
      tablet: true,
      desktop: true,
      '@type': 'ShelfPageBody_SortingOption',
      parameter: 'price-asc',
      name: 'Menor Preço',
      mobile: true,
      enabled: true,
    },
    {
      tablet: true,
      desktop: true,
      '@type': 'ShelfPageBody_SortingOption',
      parameter: 'price-desc',
      name: 'Maior Preço',
      mobile: true,
      enabled: true,
    },
    {
      tablet: true,
      desktop: true,
      '@type': 'ShelfPageBody_SortingOption',
      parameter: 'best-seller-asc',
      name: 'Os máis vendidos',
      mobile: true,
      enabled: true,
    },
  ],
  quickFilter: true,
};

export const defaultAcesSortingOptions: DefaultSortingOptionsObject = {
  quickFilter: true,
  options: [
    ...commonDefaultSortingOptions,
    {
      tablet: true,
      desktop: true,
      '@type': 'ShelfPageBody_SortingOption',
      parameter: 'recently-added',
      name: 'Recently Added',
      mobile: true,
      enabled: true,
    },
    {
      tablet: true,
      desktop: true,
      '@type': 'ShelfPageBody_SortingOption',
      parameter: 'customer-rating',
      name: 'Customer Rating',
      mobile: true,
      enabled: true,
    },
    {
      tablet: true,
      desktop: true,
      '@type': 'ShelfPageBody_SortingOption',
      parameter: 'best-sellers',
      name: 'Best Sellers',
      mobile: true,
      enabled: true,
    },
  ],
};

export const defaultAcesSortingOptionsForBR: DefaultSortingOptionsObject = {
  options: [
    {
      tablet: true,
      desktop: true,
      '@type': 'ShelfPageBody_SortingOption',
      parameter: 'price-asc',
      name: 'Menor Preço',
      mobile: true,
      enabled: true,
    },
    {
      tablet: true,
      desktop: true,
      '@type': 'ShelfPageBody_SortingOption',
      parameter: 'price-desc',
      name: 'Maior Preço',
      mobile: true,
      enabled: true,
    },
  ],
  quickFilter: true,
};

export const defaultAcesSortingOptionsForMX: DefaultSortingOptionsObject = {
  options: [
    ...commonDefaultSortingOptionsForMX,
    {
      tablet: true,
      desktop: true,
      '@type': 'ShelfPageBody_SortingOption',
      parameter: 'recently-added',
      name: 'Añadido Recientemente',
      mobile: true,
      enabled: true,
    },
    {
      tablet: true,
      desktop: true,
      '@type': 'ShelfPageBody_SortingOption',
      parameter: 'best-sellers',
      name: 'Más Vendido',
      mobile: true,
      enabled: true,
    },
  ],
  quickFilter: true,
};
